import { render } from "./Time.vue?vue&type=template&id=64cb5402&scoped=true"
import script from "./Time.vue?vue&type=script&lang=js"
export * from "./Time.vue?vue&type=script&lang=js"

import "./Time.vue?vue&type=style&index=0&id=64cb5402&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64cb5402"]])

export default __exports__